module.exports = __webpack_public_path__ + "img/tipimg_o@2x.d461aef5.png";